// data/office-addresses.ts
// The fallback list only. The business card's actual office address
// picker is populated live from the WordPress sales network data
// (lib/businesscard/office-addresses.ts, reusing lib/data/branches.ts's
// cached fetch); this static entry is what's shown if that fetch fails,
// returns nothing, or hasn't resolved yet.
export interface OfficeAddress {
  key: string;
  nameEn: string;
  nameAr: string;
  addressEn: string;
  addressAr: string;
}

export const officeAddresses: OfficeAddress[] = [
  {
    key: "hq",
    nameEn: "Head Office",
    nameAr: "المكتب الرئيسي",
    addressEn: "Alwasail Industrial Company, Head Office",
    addressAr: "شركة الوسائل الصناعية، المكتب الرئيسي",
  },
  {
    key: "general-sales",
    nameEn: "General Sales Department",
    nameAr: "إدارة المبيعات العامة",
    addressEn: "Alwasail Industrial Company, General Sales Department",
    addressAr: "شركة الوسائل الصناعية، إدارة المبيعات العامة",
  },
];

// Company locations that are NOT in the WordPress sales network (that feed
// lists customer facing branches, so it has no Head Office, warehouse, or
// plant entries). These are merged in alongside the live list rather than
// replacing it, so they are always offered — see hooks/use-office-addresses.
// "other" is deliberately last and carries no address of its own: it exists
// so someone can be recorded at a site not listed yet.
export const extraOfficeAddresses: OfficeAddress[] = [
  {
    key: "main-warehouse",
    nameEn: "Main Warehouse",
    nameAr: "المستودع الرئيسي",
    addressEn: "Alwasail Industrial Company, Main Warehouse",
    addressAr: "شركة الوسائل الصناعية، المستودع الرئيسي",
  },
  {
    key: "crusher",
    nameEn: "Crusher",
    nameAr: "الكسارة",
    addressEn: "Alwasail Industrial Company, Crusher",
    addressAr: "شركة الوسائل الصناعية، الكسارة",
  },
  {
    key: "factory-office-modon",
    nameEn: "Factory Office Modon",
    nameAr: "مكتب المصنع مدن",
    addressEn: "Alwasail Industrial Company, Factory Office Modon",
    addressAr: "شركة الوسائل الصناعية، مكتب المصنع مدن",
  },
  {
    key: "other",
    nameEn: "Other",
    nameAr: "أخرى",
    addressEn: "Other",
    addressAr: "أخرى",
  },
];

export const DEFAULT_OFFICE_ADDRESS_KEY = "hq";

// A live sales network key (e.g. "branch-123-0") is never known ahead of
// time here, so this is a lenient sanity check (a real, non-empty key was
// persisted), not membership in the small static list above. The actual
// key gets re-validated server side against the live list on every render
// or send (lib/businesscard/office-addresses.ts's resolveOfficeAddress),
// which never rejects, only falls back.
export function isValidOfficeAddressKey(key: string | null | undefined): boolean {
  return typeof key === "string" && key.trim().length > 0;
}
